<template>
  <div class="file-preview" style="margin-top: 10px">
    <div class="file-item" v-for="(file, index) in fileList" :key="index">
      <el-link :href="file.url" :underline="false" target="_blank" class="file-link">
        <i class="el-icon-document"></i>
        <span class="file-name">{{ file.name }}</span>
      </el-link>
      <div class="file-actions">
        <el-button size="small" type="text" @click="downloadFile(file.url)" icon="el-icon-download">
          下载
        </el-button>
      </div>
    </div>

    <div v-if="fileList.length === 0" class="empty-state">
      暂无文件
    </div>
  </div>
</template>

<script>
export default {
  name: "FilePreview",
  props: {
    // 接收逗号分隔的文件链接字符串
    fileUrls: {
      type: String,
      default: ''
    },
    // 自定义文件名显示（可选）
    fileNames: {
      type: String,
      default: ''
    }
  },
  computed: {
    fileList() {
      if (!this.fileUrls) return [];

      const urls = this.fileUrls.split(',');
      const names = this.fileNames ? this.fileNames.split(',') : [];

      return urls.map((url, index) => {
        // 提取文件名，如果没有自定义名称，则从URL中提取
        let fileName = '';
        if (names[index]) {
          fileName = names[index];
        } else {
          // 从URL中提取文件名
          const pathParts = url.split('/');
          fileName = pathParts[pathParts.length - 1] || url;
        }

        return {
          url: url.trim(),
          name: fileName.trim()
        };
      });
    }
  },
  methods: {
    downloadFile(url) {
      // 创建隐藏的下载链接
      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>

<style scoped>
.file-preview {
  max-width: 100%;
}

.file-item {
  display: flex;
  justify-content: space-between;  /* 文件名左对齐，按钮右对齐 */
  align-items: center;
  padding: 5px;
  border: 1px solid #eee;
  margin-bottom: 10px;
  border-radius: 5px;

  &:hover {
    background-color: #ABD4EF;
    border: solid 1px #ABD4EF;
  }


}

.empty-state {
  color: #999;
  font-style: italic;
  text-align: center;
  padding: 20px;
}
</style>
